
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brokers",
      function () {
        return require("private-next-pages/brokers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brokers"])
      });
    }
  